import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'vndCurrency'
})
export class VndCurrencyPipe implements PipeTransform {
    transform(value: any): string {
        if (value === null || value === undefined || value === '') {
            return '0 VNĐ';
        }

        const number = Number(value);
        if (isNaN(number)) {
            return '0 VNĐ';
        }

        // Định dạng số theo chuẩn Việt Nam (dấu chấm phân cách hàng nghìn)
        const formatted = new Intl.NumberFormat('vi-VN').format(number);

        return `${formatted} VNĐ`;
    }
}
